import styled from "styled-components";
import { Button, Flex, Image, Layout, Menu, Typography } from "antd";
import { COLORS } from "../../../utils/colors";

const { Sider } = Layout;
const { Text } = Typography;

export const StyledSider = styled(Sider)<{ $mobileOpen?: boolean }>`
  && {
    background: ${COLORS.surface};
    border-right: 1px solid #ececec;
    min-height: 100vh;
    position: relative;
  }

  && .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 22px 0;
  }

  @media (max-width: 991px) {
    && {
      position: fixed;
      z-index: 1000;
      top: 0;
      left: 0;
      height: 100vh;
      transform: translateX(
        ${({ $mobileOpen }) => ($mobileOpen ? "0" : "-100%")}
      );
      transition: transform 0.25s ease;
      box-shadow: ${({ $mobileOpen }) =>
        $mobileOpen ? "0 0 40px rgba(16, 24, 40, 0.18)" : "none"};
    }
  }
`;

export const SidebarBackdrop = styled.div<{ $mobileOpen?: boolean }>`
  display: none;

  @media (max-width: 991px) {
    display: ${({ $mobileOpen }) => ($mobileOpen ? "block" : "none")};
    position: fixed;
    inset: 0;
    z-index: 999;
    background: rgba(16, 24, 40, 0.45);
  }
`;

export const SidebarLogoRow = styled(Flex)<{ $collapsed?: boolean }>`
  && {
    padding: ${({ $collapsed }) => ($collapsed ? "0 12px 18px" : "0 20px 22px")};
    border-bottom: 1px solid ${COLORS.divider};
    flex-direction: ${({ $collapsed }) => ($collapsed ? "column" : "row")};
  }
`;

export const SidebarBrand = styled(Flex)<{ $collapsed?: boolean }>`
  && {
    min-width: 0;
    flex: ${({ $collapsed }) => ($collapsed ? "0 0 auto" : "1")};
    justify-content: ${({ $collapsed }) =>
      $collapsed ? "center" : "flex-start"};
  }
`;

export const SidebarLogoImage = styled(Image)`
  && {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const SidebarBrandIcon = styled(Image)`
  && {
    width: 32px !important;
    height: 32px !important;
    object-fit: contain;
  }
`;

export const SidebarCollapseButton = styled(Button)`
  && {
    width: 26px;
    height: 26px;
    min-width: 26px;
    padding: 0;
    border: 1px solid ${COLORS.border};
    border-radius: 6px;
    color: ${COLORS.textMuted};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${COLORS.surface};
    flex-shrink: 0;

    &:hover {
      color: ${COLORS.textBody};
      border-color: #c7d2e0;
      background: ${COLORS.surface};
    }
  }

  @media (max-width: 991px) {
    && {
      width: 34px;
      height: 34px;
      min-width: 34px;
      border-radius: 8px;
    }
  }
`;

export const SidebarSectionLabel = styled(Text)`
  && {
    display: block;
    padding: 18px 24px 8px;
    font-family: "Roboto", sans-serif;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1px;
    color: ${COLORS.textSubtle};
    text-transform: uppercase;
  }
`;

export const SidebarMenu = styled(Menu)`
  && {
    border-inline-end: none !important;
    background: transparent;
    padding: 0 14px;
  }

  && .ant-menu-item {
    height: 38px;
    line-height: 38px;
    margin: 4px 0 !important;
    padding: 0 14px !important;
    border-radius: 8px;
    color: #4b5563;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 500;
    width: auto;
  }

  && .ant-menu-item:hover {
    background: ${COLORS.surfaceMuted} !important;
    color: ${COLORS.textBody} !important;
  }

  && .ant-menu-item-selected {
    background: ${COLORS.surfaceSelected} !important;
    color: ${COLORS.primary} !important;
    font-weight: 600;
  }

  && .ant-menu-item-disabled,
  && .ant-menu-item-disabled:hover {
    color: ${COLORS.textSubtle} !important;
    background: transparent !important;
    opacity: 0.6;
    cursor: not-allowed !important;
  }

  && .ant-menu-item-disabled .anticon {
    color: ${COLORS.textSubtle} !important;
  }

  && .ant-menu-item .anticon {
    font-size: 16px;
  }

  && .ant-menu-item-selected .anticon {
    color: ${COLORS.primary};
  }
`;

export const SidebarSpacer = styled(Flex)`
  &&,
  &&:empty {
    display: block;
    flex: 1;
  }
`;

